import { render, staticRenderFns } from "./AS_PayBill.vue?vue&type=template&id=3c08fdd7&scoped=true&"
import script from "./AS_PayBill.vue?vue&type=script&lang=js&"
export * from "./AS_PayBill.vue?vue&type=script&lang=js&"
import style0 from "./AS_PayBill.vue?vue&type=style&index=0&id=3c08fdd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c08fdd7",
  null
  
)

export default component.exports